<template>
  <section id="text">
    <div class="container">
      <h1>{{ $t("FAQ") }}</h1>
      <div class="accordion">
        <template v-for="index in 8">
          <div
          v-if="$te(`title_${index}`)"
            class="accordion-item"
            :class="{ active: index === 1 }"
            @click="toggleItem"
          >
            <h3>{{ $t(`title_${index}`) }}</h3>
            <div class="content">
              <p v-html="$t(`text_${index}`)"></p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  methods: {
    toggleItem(event) {
      $(".accordion-item").removeClass("active");
      $(event.target).closest(".accordion-item").addClass("active");
    },
  },
};
</script>
